module.exports = __webpack_public_path__ + "img/77400.5db3d7fb.jpg";